<app-header></app-header>
<app-page-title></app-page-title>

<div class="container-fluid mb-4">
  <div class="row g-3">
    <div class="col-lg-3">
      <select [(ngModel)]="regionFilter" class="form-select">
        <option value="">Select Region</option>
        <option *ngFor="let regionRow of regionList" [value]="regionRow.region_name">
          {{regionRow.region_name}}
        </option>
      </select>
    </div>

    <div class="col-lg-3">
      <input autocomplete="off" pattern="^[^<>]*$"
             type="text"
             placeholder="Start Date"
             class="form-control"
             #startDatePicker="bsDatepicker"
             bsDatepicker
             [bsValue]="startReportDate"
             [maxDate]="maxStartDate"
             (bsValueChange)="onStartDateChange($event)">
      <timepicker [showMeridian]="false" [(ngModel)]="startReportTime" class="w-100 mt-2"></timepicker>
    </div>

    <div class="col-lg-3">
      <input autocomplete="off" pattern="^[^<>]*$"
             type="text"
             placeholder="End Date"
             class="form-control"
             #endDatePicker="bsDatepicker"
             bsDatepicker
             [bsValue]="endReportDate"
             [maxDate]="maxEndDate"
             (bsValueChange)="onEndDateChange($event)">
      <timepicker [showMeridian]="false" [(ngModel)]="endReportTime" class="w-100 mt-2"></timepicker>
    </div>

    <div class="col-lg-3">
      <button class="btn btn-primary" (click)="getExceededIndustry()">
        <i class="icon icon-search4"></i>Search
      </button>
    </div>
  </div>
</div>

<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div *ngIf="firstLevelExceedance" class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h5 class="card-title mb-0">Monitoring Report of Device Exceedance Status</h5>
          <span>
            <button (click)="exportReport('excel')" class="btn btn-outline-primary btn-sm" title="Export Excel">
            <i class="icon icon-file-excel"></i>
          </button>
          <a id="exportexcelhref" target="_blank"></a>
          </span>

        </div>

        <div class="card-body">
          <div class="table-responsive">
            <table *ngIf="!regionLoaderExceedance" class="table table-hover">
              <thead class="table-light">
              <tr>
                <th>S.No</th>
                <th>Name of Officer Designation</th>
                <th>Cell</th>
                <th>Area Jurisdiction</th>
                <th class="text-center">Total No of Industries</th>
                <th class="text-center">No of Industries Exceeded Parameter</th>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngFor="let regionDetail of firstLevelExceedance | keyvalue; let i = index">
                <tr *ngFor="let region of regionDetail.value | keyvalue">
                  <td>{{i+1}}</td>
                  <td>{{region.value.name}}</td>
                  <td>{{region.value.city}}</td>
                  <td>{{region.key}}</td>
                  <td class="text-center">{{region.value.industry_count}}</td>
                  <td class="text-center">
                    <a *ngIf="region.value.exceedance_count"
                       (click)="getExceedanceIndustryList(region.key,region.value.name)"
                       data-bs-toggle="modal"
                       data-bs-target="#secondLevel"
                       class="text-decoration-none">
                      {{region.value.exceedance_count}}
                    </a>
                    <span *ngIf="!region.value.exceedance_count" class="text-muted">
                        {{region.value.exceedance_count}}
                      </span>
                  </td>
                </tr>
              </ng-container>
              </tbody>
              <tfoot>
              <tr>
                <td></td>
                <td colspan="3" class="text-center fw-bold">Total</td>
                <td class="text-center fw-bold">{{industrySum()}}</td>
                <td class="text-center fw-bold">{{exceedanceIndustrySum()}}</td>
              </tr>
              </tfoot>
            </table>
          </div>

          <div *ngIf="regionLoaderExceedance" class="text-center py-5">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!firstLevelExceedance && !regionLoaderExceedance" class="text-center py-5">
        <div class="fs-3 fw-bold text-danger">
          No Close Unit Station Report Found
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="secondLevel" tabindex="-1" aria-labelledby="secondLevelLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" *ngIf="!moreDetailDrilledExceedance">
          {{selectedOfficerNameExceedance}} | {{selectedRegionNameExceedance}}
        </h5>
        <h5 class="modal-title" *ngIf="moreDetailDrilledExceedance">
          {{selectedIndustryNameExceedance}} | {{selectedIndustryAddressExceedance}}
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div *ngIf="!moreDetailDrilledExceedance">
          <div class="table-responsive">
            <table class="table table-hover">
              <thead class="table-light">
              <tr>
                <th>Name of Unit Station</th>
                <th>Address of Unit Station</th>
                <th>District</th>
                <th>Name of Parameter Exceeded</th>
                <th>Average Exceedance Parameter</th>
                <th>Details of Exceedance</th>
              </tr>
              </thead>
              <tbody *ngIf="!industryLoaderExceedance">
              <tr *ngFor="let industry of exceedanceIndustryList | keyvalue">
                <td>{{industry.value.name}}</td>
                <td>{{industry.value.address}}</td>
                <td>{{industry.value.city}}</td>
                <td>{{industry.value.all_parameter}}</td>

<!--                <td><strong>{{industryParameterCount[industry.value.id]['percentage']}} %</strong></td>-->
                <td>
                  <ng-container *ngFor="let param of getParameterPercentageList(industry.value)">
                    <div>
                      <strong>{{ param.key.toUpperCase() }}:</strong> {{ param.value }}%
                    </div>
                  </ng-container>
                </td>

                <td>
                  <button (click)="getIndustryExceedanceHistory(industry.value.name,industry.value.address,industry.value.id)"
                          class="btn btn-sm btn-primary">
                    <i class="icon icon-more2"></i>
                  </button>
                </td>
              </tr>
              </tbody>
              <tbody *ngIf="industryLoaderExceedance">
              <tr>
                <td colspan="6" class="text-center py-5">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div *ngIf="moreDetailDrilledExceedance">
          <button (click)="backToPreviousLevelExceedance()" class="btn btn-sm btn-primary mb-3">
            <i class="icon icon-arrow-left5 me-2"></i> Back
          </button>
          <div class="table-responsive">
            <table class="table table-hover">
              <thead class="table-light">
              <tr>
                <th class="text-center">Exceedance Date & Time</th>
                <th class="text-center">Parameter Exceedance Name</th>
                <th class="text-center">Exceedance Value of Parameter</th>
                <th class="text-center">Prescribed Limit of Parameter</th>
              </tr>
              </thead>
              <tbody *ngIf="!historyLoaderExceedance">
              <tr *ngFor="let history of exceedanceIndustryHistory | keyvalue">
                <td class="text-center">{{history.value.excedance_date | date: 'dd MMM yyyy HH:mm'}}</td>
                <td class="text-center"><strong>{{history.value.name}}</strong></td>
                <td class="text-center"><strong>{{history.value.value}} {{history.value.unit}}</strong></td>
                <td class="text-center">{{history.value.max}} {{history.value.unit}}</td>
              </tr>
              </tbody>
              <tbody *ngIf="historyLoaderExceedance">
              <tr>
                <td colspan="4" class="text-center py-5">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
